<app-header [label]="params?.id ? 'Update Script' : 'Add Script'"></app-header>
<form [formGroup]="form" class="bg-gray-50 h-[calc(100vh-110px)] flex flex-col">
  <div class="flex-1 overflow-auto p-4 pb-0">
    <!-- Top dropdowns -->
    <div class="bg-white border border-gray-200 rounded-xl p-4 mb-4">
      <div class="grid grid-cols-2 gap-4">
        <app-select-input label="University" class="w-full" [is_required]="true" [depended]="1" formControlName="university_id" [options]="dds.dropdown_list?.assessment_university_list" (valueChange)="gs.onDropdownChange($event)" (registerSelf)="gs.registerDropdown($event)"></app-select-input>
        <app-select-input label="Academic Year" class="w-full" [is_required]="true" [depended]="2" formControlName="academic_year_id" [options]="form.get('university_id')?.value ? (dds.dropdown_list?.assessment_academicyear_list | filterByKeyAndValue : 'university_id' : form.get('university_id')?.value) : []" (valueChange)="gs.onDropdownChange($event)" (registerSelf)="gs.registerDropdown($event)"></app-select-input>
        <app-select-input label="Exam" class="w-full" [is_required]="true" [depended]="3" formControlName="exam_id" [options]="(form.get('university_id')?.value && form.get('academic_year_id')?.value) ? (dds.dropdown_list?.assessment_exam_and_code_list | filterByKeyAndValue : 'AcademicYear.id' : form.get('academic_year_id')?.value | filterByKeyAndValue : 'university_id' : form.get('university_id')?.value) : []" (valueChange)="gs.onDropdownChange($event)"
          (registerSelf)="gs.registerDropdown($event)"></app-select-input>
        <app-select-input label="Subject" (ngModelChange)="create_directory()" class="w-full" [is_required]="true" [depended]="4" formControlName="subject_id" [options]="(form.get('university_id')?.value && form.get('exam_id')?.value) ? (dds.dropdown_list?.assessment_subject_and_code_list | filterByKeyAndValue : 'exam_id' : form.get('exam_id')?.value | filterByKeyAndValue : 'university_id' : form.get('university_id')?.value | filterByKeyAndValue : 'academic_year_id' : form.get('academic_year_id')?.value) : []"
          (valueChange)="gs.onDropdownChange($event)" (registerSelf)="gs.registerDropdown($event)"></app-select-input>
      </div>
    </div>

    <!-- Script & Supplement Configuration -->
    <div class="bg-white border border-gray-200 rounded-xl p-4 mb-4">
      <!-- Directory row -->
      <div class="grid grid-cols-2 gap-4 mb-4">
        <div class="flex items-center gap-2 border border-gray-300 rounded-lg px-3 h-12 bg-gray-100 min-w-0">
          <i class="bx bx-folder text-gray-500 text-lg flex-shrink-0"></i>
          <span class="text-sm text-gray-700 flex-1 truncate" [title]="form.get('answer_script_directory')?.value">
            {{ form.get('answer_script_directory')?.value || 'Directory' }}
          </span>
          <button type="button" (click)="copy_directory()" class="flex-shrink-0">
            <i class="bx bx-copy-alt text-primary text-lg"></i>
          </button>
        </div>
        <div class="flex items-center">
          <button *ngIf="link_copied" type="button" class="border border-gray-300 rounded-lg px-4 h-12 text-sm text-gray-600">
            Link Copied
          </button>
        </div>
      </div>
      <!-- Pages inputs -->
      <div class="grid grid-cols-2 gap-4">
        <div>
          <app-text-input class="w-full" [disabled]="true" type="number" label="Total Pages per Script" formControlName="no_of_pages_per_script"></app-text-input>
          <p class="text-xs text-gray-500 mt-1 italic">Total number of pages in one answer script.</p>
        </div>
        <div>
          <app-text-input class="w-full" [disabled]="true" type="number" label="Pages per Supplement" formControlName="no_of_pages_per_supplement"></app-text-input>
          <p class="text-xs text-gray-500 mt-1 italic">Total number of pages in one Supplement.</p>
        </div>
      </div>
    </div>

    <!-- Image Processing -->
    <div class="bg-white border border-gray-200 rounded-xl mb-4">
      <h3 class="font-medium text-base mb-4 p-4 pb-0">Image Processing</h3>
      <div class="grid grid-cols-3 gap-4 items-start p-4 pt-0">
        <div>
          <app-text-input class="w-full" [is_required]="true" label="Image Prefix" placeholder="e.g., IMG_" formControlName="image_prefix"></app-text-input>
          <p class="text-xs text-gray-500 mt-1 italic">Prefix for image file names</p>
        </div>
        <div>
          <p class="text-sm text-gray-600 mb-3">Image Format <span class="text-red-700 ml-0.5">*</span></p>
          <div class="flex gap-4 items-center">
            <label class="flex items-center gap-2 cursor-pointer">
              <input type="checkbox" [checked]="isFormatSelected('jpg')" (change)="toggleImageFormat('jpg', $event)" class="w-4 h-4 accent-primary">
              <span class="text-sm">JPG</span>
            </label>
            <label class="flex items-center gap-2 cursor-pointer">
              <input type="checkbox" [checked]="isFormatSelected('png')" (change)="toggleImageFormat('png', $event)" class="w-4 h-4 accent-primary">
              <span class="text-sm">PNG</span>
            </label>
            <label class="flex items-center gap-2 cursor-pointer">
              <input type="checkbox" [checked]="isFormatSelected('jpeg')" (change)="toggleImageFormat('jpeg', $event)" class="w-4 h-4 accent-primary">
              <span class="text-sm">JPEG</span>
            </label>
          </div>
          <p *ngIf="form.get('image_format')?.invalid && (form.get('image_format')?.dirty || form.get('image_format')?.touched)" class="text-red-500 text-sm mt-1 ml-1">Image Format is required</p>
        </div>
      </div>
    </div>
  </div>


  <!-- Footer buttons — fixed to bottom -->
  <div class="bg-white border-t border-gray-200 px-4 py-3 flex justify-between gap-3 shadow-[0_-4px_5px_rgba(0,0,0,0.1)] z-10">
    <app-button color="border border-gray-300 text-gray-700 bg-white rounded-full" label="Validate" type="button" (click)="check_submit()"></app-button>
    <div class="flex gap-3">
      <app-button color="border border-gray-300 text-gray-700 bg-white" label="Discard" type="button" (click)="gs.go_back()"></app-button>
      <app-button color="bg-primary text-white" [label]="params?.id ? 'Update' : '+ Add'" type="button" (click)="submit()"></app-button>
    </div>
  </div>
</form>